import {Controller} from "@hotwired/stimulus";
import {Turbo} from "@hotwired/turbo-rails";
import { notifyParentOfPageScroll } from "../utils/iframe_messaging";

export default class extends Controller {
  static values = {
    url: String
  };

  static targets = ["sentinel"];

  connect() {
    if (!this.hasSentinelTarget || !this.urlValue) return;

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadNextPage();
        }
      });
    });

    this.observer.observe(this.sentinelTarget);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  loadNextPage() {
    if (!this.urlValue) return;

    this.observer.disconnect();


    const fetchOptions = {
      'method': 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-Request-Type': 'infinite-scroll',
        Accept: 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml'
      }
    };

    fetch(this.urlValue, fetchOptions)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then(html => {
        Turbo.renderStreamMessage(html);
        
        setTimeout(() => {
          const newAyahs = document.querySelectorAll('[data-ayah]');
          if (newAyahs.length > 0) {
            const lastAyah = newAyahs[newAyahs.length - 1];
            const ayahKey = lastAyah.dataset.ayah;
            if (ayahKey) {
              const [chapter, ayah] = ayahKey.split(':');
              notifyParentOfPageScroll({
                chapter: parseInt(chapter),
                ayah: parseInt(ayah),
                ayahKey: ayahKey,
                type: 'infinite_scroll',
                timestamp: Date.now()
              });
            }
          }
        }, 100);
      })
      .catch(error => console.error('Turbo stream fetch error:', error));
  }
}
